import module from 'recursoshumanos/module.js'
import template from './template.html'

const catalogoTipoMovimiento = {
  8: 'Reingreso/Alta',
  7: 'Modificación',
  2: 'Baja',
}

export class RecursoshumanosVisorlotesLoteComponent {
  operadoraId
  numeroLote
  numeroFolio
  fecha
  folio
  onClose
  data = null
  descargandoSua = false
  eliminandoLote = false
  descargandoExcel = false
  catalogo = {
    tipoMovimiento: catalogoTipoMovimiento,
  }

  constructor (RecursosHumanosVisorLotesLote, RecursoshumanosVisorlotesService, RecursoshumanosVisorloteSUAAltasMasivasService) {
    this.RecursoshumanosVisorloteSUAAltasMasivasService = RecursoshumanosVisorloteSUAAltasMasivasService
    this.RecursoshumanosVisorlotesService = RecursoshumanosVisorlotesService
    this.RecursosHumanosVisorLotesLote = RecursosHumanosVisorLotesLote
  }

  $onInit () {
    this.RecursosHumanosVisorLotesLote.get(this.operadoraId, this.folio, this.fecha)
      .then(({data}) => (this.data = data))
  }

  cerrar (data = false) {
    this.onClose({$event: {data}})
  }

  descargarSUA () {
    if (this.descargandoSua) return

    this.descargandoSua = true
    this.RecursoshumanosVisorloteSUAAltasMasivasService.get({idEmpresa: this.operadoraId, numeroLote: this.numeroLote})
      .then(({data}) => (data.save()))
      .finally(() => (this.descargandoSua = false))
  }

  descargarExcel () {
    if (this.descargandoExcel) return

    this.descargandoExcel = true
    this.RecursoshumanosVisorlotesService.exportarXLS(this.data, this.numeroLote, this.numeroFolio)
      .finally(() => (this.descargandoExcel = false))
  }

  eliminarLote () {
    this.eliminandoLote = true
  }

  eliminar (data) {
    this.eliminandoLote = false
    this.cerrar(data)
  }
}

module.component('recursoshumanosVisorlotesLote', {
  controller: RecursoshumanosVisorlotesLoteComponent,
  template: template,
  bindings: {
    operadoraId: '<',
    numeroLote: '<',
    numeroFolio: '<',
    fecha: '<',
    folio: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/visorlotes/lote/component.js